import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Fontawesome from "../../../../components/fontawesome/fontawesome";
import {
  LocationMonitoring,
  IconLocationMonitoring,
  IconArrowLocation,
  Location,
  TotalItems,
  Button,
  Situations,
  Status,
  Chip,
  StatusText,
  ButtonIcon,
  Rotate,
  RowCards,
  ColCard,
} from "./styles";
import { useFetch } from "../../../../../components/hooks/useFetch";
import { Prefix } from "../../../../../services/prefix";
import Loading from "../../../../../components/loader/loading";
import { StoreContext } from "../../../../../stores/inject";
import { observer } from "mobx-react-lite";
import { ButtonViewPlant } from "../../sensorDashboardModal";
import { MonitoringCard } from "../MonitoringCard";

const RoomMonitoring = ({
  unit,
  idUnit,
  nameUnit,
  idRoom,
  idSector,
  showNameUnit,
  customerName,
  setAllRooms,
  filter,
  newValueContractItem
}) => {
  const [opens, setOpens] = useState([]);
  const { sensorStore, roomStore } = useContext(StoreContext);

  function handleOpen(id) {
    setOpens((state) =>
      state.includes(id) ? state.filter((it) => it !== id) : [...state, id]
    );
  }

  function isOpen(id) {
    return opens.includes(id);
  }

  const params = Object.entries({
    sector: idSector,
    room: idRoom,
  })
    .filter(([, value]) => !!value)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  const path = `${Prefix.replace(/[\\"]/g, "")}/sismogran/map/units/${idUnit}/rooms?${params}`;

  const listRooms = useFetch(path);

  const updatedRooms = listRooms.data?.models.map(room => {
    const updatedContractItems = room.contractItems.map(item => {
      if (newValueContractItem && item.id === newValueContractItem.contractItemId) {
        return {
          ...item,
          situation: newValueContractItem.status,
          sensors: item.sensors?.map(sensor => {
            if (sensor.id === newValueContractItem.sensorId) {
              return { ...sensor, value: newValueContractItem.value };
            }
            return sensor;
          }) ?? item.sensors,
        };
      }
      return item;
    });
    return { ...room, contractItems: updatedContractItems };
  }) || [];

  const filteredRooms = updatedRooms
    .filter(room => Array.isArray(room.contractItems))
    .filter(room => !filter || room.contractItems.some(item => item.situation === filter))
    .sort((a, b) => (b.contractItems?.length || 0) - (a.contractItems?.length || 0));

  function reduceSituations(equipments) {
    const initial = { SUCCESS: 0, WARNING: 0, DANGER: 0, DARK: 0 };
    return equipments.reduce((acc, equipment) => {
      acc[equipment.situation] += 1;
      return acc;
    }, initial);
  }

  useEffect(() => {
    if (!listRooms.data?.models) return;
    setAllRooms(state => ({ ...state, [idUnit]: listRooms.data?.models }));
    // return () => setAllRooms(state => ({ ...state, [idUnit]: [] }));
  }, [idUnit, listRooms.data, setAllRooms]);

  if (!listRooms.data) return <Loading />;

  return (
    <>
      {filteredRooms.map((room, index) => {
        const situations = reduceSituations(room.contractItems);
        const open = isOpen(room.id);

        return (
          <Col sm={12} key={index} style={{ marginTop: 10 }}>
            <LocationMonitoring>
              <Location>
                <IconLocationMonitoring src="../../../media/icons/Location.svg" />{" "}
                {["admin", "master"].includes(Prefix.replace(/[\\"]/g, "")) && (
                  <>
                    {customerName}
                    <IconArrowLocation src="../../../media/icons/arrow-location.svg" />
                  </>
                )}
                {showNameUnit ?? (
                  <>
                    {nameUnit}{" "}
                    <IconArrowLocation src="../../../media/icons/arrow-location.svg" />
                  </>
                )}
                {room.sector}
                <IconArrowLocation src="../../../media/icons/arrow-location.svg" />
                {room.name}
              </Location>
              <Situations>
                <Chip situation={"SUCCESS"} active={filter === "SUCCESS"}>
                  <Status src="/media/icons/green-light.svg" />
                  <StatusText>{situations?.SUCCESS || "--"}</StatusText>
                </Chip>
                <Chip situation="WARNING" active={filter === "WARNING"}>
                  <Status src="/media/icons/yellow-light.svg" />
                  <StatusText>{situations?.WARNING || "--"}</StatusText>
                </Chip>
                <Chip situation="DANGER" active={filter === "DANGER"}>
                  <Status src="/media/icons/red-light.svg" />
                  <StatusText>{situations?.DANGER || "--"}</StatusText>
                </Chip>
                <Chip situation="DARK" active={filter === "DARK"}>
                  <Status src="/media/icons/black-light.svg" />
                  <StatusText>{situations?.DARK || "--"}</StatusText>
                </Chip>
              </Situations>
              <TotalItems>
                <Button onClick={() => handleOpen(room.id)}>
                  <strong>{room.contractItems.length}</strong>
                  <div style={{ marginLeft: 4 }}>Equipamento(s)</div>
                  <ButtonIcon>
                    <Rotate open={open}>
                      <Fontawesome classe="fas fa-chevron-down mr-2 ml-2" />
                    </Rotate>
                  </ButtonIcon>
                </Button>
              </TotalItems>
            </LocationMonitoring>

            {open && (
              <RowCards>
                {room.contractItems
                  .filter(item => !filter || item.situation === filter)
                  .map((item, idx, arr) => {
                    const newItem = {
                      ...item,
                      updated_at: item.readed_at || item.updated_at,
                    };

                    // Define número de colunas de acordo com quantidade de itens
                    let colWidth = 25; // padrão 4 colunas
                    const count = arr.length;
                    if (count === 1 || count === 2) colWidth = 50; // 1 ou 2 itens → duas colunas
                    else if (count === 3) colWidth = 33.333; // 3 itens → 3 colunas
                    else colWidth = 33.333; // 4 ou mais → 4 colunas

                    return (
                      <ColCard key={idx} style={{
                        flex: `1 1 calc(${colWidth}% - 20px)`,
                        maxWidth: `calc(${colWidth}% - 20px)`
                      }}>
                        <MonitoringCard item={newItem} />
                      </ColCard>
                    );
                  })}
              </RowCards>

            )}
          </Col>
        );
      })}
    </>
  );
};

export default observer(RoomMonitoring);
